<div
  [ngClass]="{
    'h-full': fullHeight(),
    'justify-center': fullHeight() && !confirmed(),
    'bg-anis': confirmed(),
    'bg-gray-light': !confirmed(),
  }"
  class="flex flex-col gap-y-4 rounded-xl p-5 desk:p-7">
  <div class="font-title text-[25px]">{{ "COMPONENT.FORMULAIRE-RDV.LABEL_APPOINTMENT" | translate }}</div>
  <div class="flex gap-x-4">
    @if (confirmed()) {
      <ng-container *ngTemplateOutlet="sticker; context: { $implicit: 'assets/icons/sticker-pin.svg', width: 28 }" />
    }
    <div class="flex flex-col gap-y-2">
      <div class="font-title text-[18px]">{{ "COMPONENT.FORMULAIRE-RDV.LABEL_WHERE" | translate }}</div>
      @if (storeSelected(); as store) {
        @if (slotSelected().visioAppointmentSelected) {
          <div>
            {{ "COMPONENT.FORMULAIRE-RDV.VIDEO_APPOINTMENT_WITH_STORE" | translate }}
            <span class="font-bold">{{ store.name }}</span>
          </div>
        } @else {
          <div class="flex flex-col gap-y-1 text-base">
            <div class="flex flex-col">
              {{ "COMPONENT.FORMULAIRE-RDV.LABEL_STORE_LOCATION" | translate }}
              <span class="font-bold">{{ store.name }}</span>
            </div>
            <div class="text-base">{{ store.streetName }}, {{ store.zipcode }} {{ store.city }}</div>
          </div>
        }
        @if (canEdit()) {
          <div>
            <span (click)="onStoreChange.emit()" class="cursor-pointer font-bold">
              {{ "ACTION.EDIT" | translate }}
            </span>
          </div>
        }
      }
    </div>
  </div>
  <div class="flex gap-x-4">
    @if (confirmed()) {
      <ng-container
        *ngTemplateOutlet="sticker; context: { $implicit: 'assets/icons/sticker-calendar.svg', width: 26 }" />
    }
    <div class="flex flex-col gap-y-2">
      <div class="font-title text-[18px]">{{ "COMPONENT.FORMULAIRE-RDV.LABEL_WHEN" | translate }}</div>
      @if (slotSelected(); as slot) {
        <div class="text-base">
          {{ slot.dateLabel | transformFirstLetter }}
          {{ "COMPONENT.FORMULAIRE-RDV.LABEL_APPOINTMENT_DATETIME" | translate }}
          {{ slot.formattedSlots.slot }}
        </div>
        @if (canEdit()) {
          <div>
            <span (click)="onSlotChange.emit()" class="cursor-pointer font-bold">{{ "ACTION.EDIT" | translate }}</span>
          </div>
        }
      }
    </div>
  </div>
  <ng-content />
</div>

<!-- Same shape and shadow as the header pictos, at the size of the confirmation mockup. -->
<ng-template #sticker let-src let-width="width">
  <div class="relative h-[57px] w-[47px] shrink-0">
    <div class="mask-btn-menu absolute z-10 flex size-full items-center justify-center bg-white">
      <app-svg [inline]="true" [src]="src" [width]="width" />
    </div>
    <app-svg [height]="57" [width]="47" class="drop-shadow-custom absolute" src="assets/svgs/bg-menu-icon.svg" />
  </div>
</ng-template>
